import { BANCO_DAUNIA_CONTACTS } from './bancoContacts';

const {
  organization,
  legalName,
  address,
  email,
  phone,
  website,
} = BANCO_DAUNIA_CONTACTS;

/**
 * Informativa privacy per la raccolta risposte tramite inviti digitali.
 * Testo di riferimento operativo: da validare con il titolare del trattamento.
 */
export const PRIVACY_POLICY = {
  title: 'Informativa privacy',
  shortLabel: 'Informativa privacy',
  lastUpdatedLabel: 'Ultimo aggiornamento: settembre 2026',
  sections: [
    {
      title: '1. Titolare del trattamento',
      paragraphs: [
        `Il titolare del trattamento dei dati personali raccolti tramite gli inviti digitali è ${legalName} — ${organization}, con sede in ${address}.`,
        `Per qualsiasi richiesta relativa alla privacy puoi scrivere a ${email} o contattare il numero ${phone}.`,
      ],
    },
    {
      title: '2. Finalità del trattamento',
      paragraphs: [
        'I dati che inserisci nel modulo di iscrizione vengono trattati per gestire la partecipazione all’evento o all’iniziativa indicata nell’invito, comunicare informazioni organizzative (es. turni, luogo, orari) e, se necessario, adempiere a obblighi di legge.',
        'I dati non vengono utilizzati per finalità di marketing non richieste.',
      ],
    },
    {
      title: '3. Dati trattati',
      paragraphs: [
        'A seconda dei campi previsti dall’invito, possono essere raccolti dati anagrafici e di contatto (es. nome, cognome, email, telefono) e altre informazioni necessarie all’organizzazione (es. disponibilità, preferenze, note).',
        'Il conferimento dei dati obbligatori è necessario per completare l’iscrizione; in loro assenza non sarà possibile accettare la richiesta.',
      ],
    },
    {
      title: '4. Base giuridica',
      paragraphs: [
        'Il trattamento si fonda sull’esecuzione di misure precontrattuali / organizzative su richiesta dell’interessato (iscrizione all’iniziativa) e, ove previsto, sul consenso espresso attraverso i campi del modulo.',
      ],
    },
    {
      title: '5. Modalità e destinatari',
      paragraphs: [
        'I dati sono trattati con strumenti elettronici e misure di sicurezza adeguate, accessibili solo al personale autorizzato del Banco Alimentare della Daunia e a eventuali incaricati tecnici necessari al funzionamento della piattaforma.',
        'I dati non sono ceduti a terzi per finalità commerciali. Potranno essere comunicati a soggetti coinvolti nell’organizzazione dell’evento solo se strettamente necessario.',
      ],
    },
    {
      title: '6. Conservazione',
      paragraphs: [
        'I dati sono conservati per il tempo necessario a gestire l’invito/evento e gli adempimenti correlati, e comunque non oltre i termini previsti dalla normativa applicabile o dalle esigenze organizzative documentate del titolare.',
      ],
    },
    {
      title: '7. Diritti dell’interessato',
      paragraphs: [
        'Puoi esercitare i diritti previsti dal Regolamento (UE) 2016/679 (accesso, rettifica, cancellazione, limitazione, opposizione, portabilità, ove applicabili) contattando il titolare agli indirizzi indicati sopra.',
        'Hai inoltre il diritto di proporre reclamo all’Autorità Garante per la protezione dei dati personali.',
      ],
    },
    {
      title: '8. Maggiori informazioni',
      paragraphs: [
        `Per conoscere meglio l’organizzazione: ${website}`,
      ],
    },
  ],
};
